/* unplugin-vue-components disabled */import script from "./ImageCropDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageCropDialog.vue?vue&type=script&setup=true&lang=js"

import "./ImageCropDialog.vue?vue&type=style&index=0&id=650e0c6d&lang=scss"

const __exports__ = script;

export default __exports__